import gql from 'graphql-tag';

export const DELETE_CLIENT = gql`
  mutation DeleteClient($clientId: String!) {
    deleteClient(clientId: $clientId) {
      id
    }
  }
`;
